<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">

      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/MIcon.png" alt="" height="55">
          </span>
          <span class="logo-lg">
            <img src="assets/images/MFLogo.png" alt="" height="17">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/MIcon.png" alt="" height="55">
          </span>
          <span class="logo-lg">
            <img src="assets/images/MFLogo.png" alt="" height="60">
          </span>
        </a>
      </div>
      <button type="button"
              class="btn btn-sm px-3 font-size-16 header-item"
              id="vertical-menu-btn"
              (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <div class="d-flex align-items-center ms-3 topbar-app-title">
        <span class="phase-pill"
              *ngIf="topbarPhaseLabel"
              [ngClass]="{ 'phase1': topbarPhaseNumber === 1, 'phase2': topbarPhaseNumber === 2 }">
          {{ topbarPhaseLabel }}
        </span>
      </div>

    </div>

    <div class="d-flex">

      <!-- ==================== NOTIFICATION DROPDOWN ==================== -->
      <div class="dropdown d-inline-block" ngbDropdown>

        <button type="button" class="btn header-item noti-icon position-relative" ngbDropdownToggle>
          <i class="bx bx-bell"></i>

          <!-- 🔶 Pending Invoice Badge -->
          <span *ngIf="pendingInvoiceCount > 0"
                class="badge bg-danger text-white rounded-pill position-absolute"
                style="top: 5px; right: 0;">
            {{ pendingInvoiceCount }}
          </span>

          <!-- 🔴 System Notification Badge -->
          <span *ngIf="notifications.length > 0 && !hasSeenNotifications"
                class="badge bg-danger rounded-pill position-absolute"
                style="top: 5px; left: 0;">
            {{ notifications.length }}
          </span>
        </button>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
             ngbDropdownMenu
             style="width: 330px;">

          <!-- HEADER -->
          <div class="p-3 border-bottom bg-light d-flex justify-content-between align-items-center">
            <h6 class="m-0">Notifications</h6>
            <small class="text-muted">
              {{ notifications.length + pendingInvoiceCount }} total
            </small>
          </div>

          <!-- EMPTY -->
          <div *ngIf="notifications.length === 0 && pendingInvoiceCount === 0"
               class="px-3 py-3 text-center text-muted">
            No notifications
          </div>

          <!-- 🔶 PENDING INVOICE SECTION (visible only for Phase-2 because TS prevents Phase-1) -->
          <div *ngIf="pendingInvoiceCount > 0"
               class="px-3 py-2 border-bottom bg-warning-light cursor-pointer"
               (click)="goToPendingInvoices()">

            <div class="d-flex justify-content-between align-items-center">
              <strong class="text-dark">
                {{ pendingInvoiceCount }} Pending Invoice(s)
              </strong>
              <span class="badge bg-danger text-white">
                {{ pendingInvoiceCount }}
              </span>
            </div>

            <div class="text-muted small">
              Waiting to be pushed to ZATCA
            </div>

          </div>

          <!-- 🔔 SYSTEM NOTIFICATIONS -->
          <div *ngIf="notifications.length > 0"
               class="px-3 py-2"
               style="max-height: 300px; overflow-y: auto;">

            <ng-container *ngFor="let n of notifications">
              <div class="dropdown-item d-flex align-items-start py-2 px-0 border-bottom">
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1 fw-semibold">{{ n.title }}</h6>
                  <p class="mb-0 text-muted small">{{ n.msgtxt }}</p>
                </div>
                <i class="bx bx-info-circle text-primary fs-5"></i>
              </div>
            </ng-container>

          </div>

        </div>
      </div>

      <!-- ==================== MOBILE SEARCH ==================== -->
      <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" ngbDropdownToggle>
          <i class="mdi mdi-magnify"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu></div>
      </div>

      <!-- ==================== LANGUAGE ==================== -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button"
                class="btn header-item"
                id="page-header-user-dropdown"
                ngbDropdownToggle>

          <img *ngIf="flagvalue" [src]="flagvalue" alt="Language" height="16">
          <span class="ms-1">{{ countryName }}</span>

          <img *ngIf="!flagvalue" [src]="valueset" height="16">
          <span *ngIf="!flagvalue" class="ms-1">English</span>

        </button>

        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <a href="javascript:void(0);"
             class="dropdown-item notify-item"
             *ngFor="let item of listLang"
             (click)="setLanguage(item.text, item.lang, item.flag)"
             [ngClass]="{'active': cookieValue === item.lang}">
            <img [src]="item.flag" class="me-1" height="12">
            <span class="align-middle">{{ item.text }}</span>
          </a>
        </div>
      </div>

      <!-- FULLSCREEN BUTTON -->
      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <!-- ==================== USER MENU ==================== -->
      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle>
          <img class="rounded-circle header-profile-user"
               src="assets/images/users/avatar-1.jpg" alt="Header Avatar">
          <span class="d-none d-xl-inline-block ms-1">{{ _userName }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript:void(0);" (click)="logout()">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate }}
          </a>
        </div>
      </div>

    </div>
  </div>
</header>
